import { PageContainer } from '../../../shared/PageContainer';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { PageDefaultSegment } from "@sis/react-library";
import { useState } from 'react';
import { FormSamplesOutput } from '../FormSamplesOutput';
import { Button, Typography } from '@mui/material';
import { FormSamplesWithinDialogDialog } from './FormSamplesWithinDialogDialog';
import { FormSamplesWithinDialogPageInfo } from './FormSamplesWithinDialogPageInfo';

/////////////////////////////////////////////////////////////////////////////////////////////
// Existing interface (would be defined elsewhere in the project).
/////////////////////////////////////////////////////////////////////////////////////////////
export interface FeedbackDto {
    name: string;
    surname: string;
    feedback: string;
    email: string;
}

export const FormSamplesWithinDialogPage = () => {

    const [showFormDialog, setShowFormDialog] = useState(false);
    const [displaySubmittedValues, setDisplaySubmittedValues] = useState<FeedbackDto | undefined>(undefined)

    const handleShowFormDialog = () => {
        setShowFormDialog(true);
    }

    const handleCloseFormDialog = () => {
        setShowFormDialog(false);
    }

    return (
        <PageContainer
            heading='Form Samples - Within a Dialog'
            icon={<TextSnippetIcon />}
            pageInfo={<FormSamplesWithinDialogPageInfo />}
        >
            <PageDefaultSegment>
                <Typography>
                    Click the buttons below to show the form in a dialog.
                </Typography>
                <Button
                    variant="contained"
                    sx={{ marginTop: 2 }}
                    onClick={() => { handleShowFormDialog() }}
                >
                    Show Dialog Form
                </Button>
            </PageDefaultSegment>
            <FormSamplesOutput width={400} submittedValues={displaySubmittedValues} />
            <FormSamplesWithinDialogDialog
                open={showFormDialog}
                onClose={handleCloseFormDialog}
                setDisplaySubmittedValues={setDisplaySubmittedValues}
            />
        </PageContainer>
    )
}
